// extracted by mini-css-extract-plugin
export default {"button":"button__YI91YKRd","tooltip":"tooltip__vXZXIUvm","tooltipText":"tooltipText__Yudyypjx"};